import { __rest, __assign } from '../node_modules/tslib/tslib.es6.esm.js';
import * as React from 'react';
import VariantContainer from './VariantContainer.esm.js';
import VariantInline from './VariantInline.esm.js';

var NvRadioButton = function (props) {
    var selected = props.selected, className = props.className, onClick = props.onClick, label = props.label, disabled = props.disabled, variant = props.variant, customLabel = props.customLabel, containerProps = __rest(props, ["selected", "className", "onClick", "label", "disabled", "variant", "customLabel"]);
    var genericProps = { className: className, customLabel: customLabel, disabled: disabled, label: label, onClick: onClick, selected: selected };
    if (variant === 'container') {
        return React.createElement(VariantContainer, __assign({}, containerProps, genericProps));
    }
    return React.createElement(VariantInline, __assign({}, genericProps));
};

export { NvRadioButton as default };
//# sourceMappingURL=NvRadioButton.esm.js.map
